import React from "react";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import "../../../../../styles/Pages/Financial/CashOutFlow/Dashboard/LineGraphChart.style.css";

import {
  CartesianGrid,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const LineGraphChart = ({ graphData }) => {
  return (
    <div className="academicAndResidentialExpensesLineChartComponent">
      <div className="graphHeader">
        <h3>Academic & residential expenses</h3>
        <ul className="legend">
          <li>Academic</li>
          <li>Residential</li>
        </ul>
        <SelectFilter />
      </div>
      <div className="graphContent">
        <LineChart
          width={680}
          height={335}
          data={graphData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          {/* <Legend /> */}
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis
            // label={{ value: "Expenses", angle: -90, position: "insideLeft" }}
            domain={[0, 90000]}
            ticks={[
              0, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000,
            ]}
            tickFormatter={(value) => `${value / 1000}k`}
          />
          <Tooltip formatter={(value) => `${value}`} />

          <Line
            type="monotone"
            dataKey="academic"
            name="Academic"
            stroke="#0000FF"
            strokeWidth={2}
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey="residential"
            name="Residential"
            stroke="#FF0000"
            strokeWidth={2}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </div>
    </div>
  );
};

export default LineGraphChart;
